/**
 * @desc 删除实例数据
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  params: API.activiti.activiti.deleteProcessByBpm.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/deleteProcessByBpm`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
